// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import checkVerified03Icon from "@/assets/icons/check-verified-03.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type CheckVerified03IconProps = Omit<IconProps, "name">;

export function CheckVerified03Icon(props: CheckVerified03IconProps): React.ReactNode {
  return <Icon name={checkVerified03Icon} {...props} />;
}
